import api from "../api";

// About Us Section CRUD
export const fetchAboutUsSections = async () => {
  const res = await api.get("/about-us-sections");
  // API returns { success, sections: [...] }
  if (!Array.isArray(res.data.sections)) return [];
  return res.data.sections.map((section: any, idx: number) => ({
    color: section.icon_color || "primary",
    content: section.content,
    icon: section.icon || "HiUser",
    id: section.id?.toString() ?? `${idx}`,
    imageAlt: section.image_alt,
    imageUrl: section.image_path
      ? `${import.meta.env.VITE_API_STORAGE_URL}/storage/${section.image_path}`
      : "",
    isActive: !section.hidden,
    order: idx,
    sectionType: section.section_type,
    title: section.title,
  }));
};

export const addAboutUsSection = async (formData: FormData | object) => {
  return api.post("/about-us-sections", formData);
};

export const updateAboutUsSection = async (
  id: number | string,
  formData: FormData | object,
) => {
  return api.post(`/about-us-sections/${id}`, formData);
};

export const hideAboutUsSection = async (id: number | string) => {
  return api.post(`/about-us-sections/${id}/hide`);
};

export const unhideAboutUsSection = async (id: number | string) => {
  return api.post(`/about-us-sections/${id}/unhide`);
};

export const deleteAboutUsSection = async (id: number | string) => {
  return api.delete(`/about-us-sections/${id}`);
};

// About Us Page Config
export const fetchAboutUsPageConfig = async () => {
  const res = await api.get("/about-us-page-config");
  return res.data?.config || res.data;
};

export const addAboutUsPageConfig = async (formData: FormData | object) => {
  return api.post("/about-us-page-config", formData);
};

export const updateAboutUsPageConfig = async (
  id: number | string,
  formData: FormData | object,
) => {
  return api.post(`/about-us-page-config/${id}`, formData);
};
